import React from "react";
import { useAuth } from "@/context/AuthContext";
import { canUseStaffPage } from "@/lib/page-permissions";
import KioskPage from "@/pages/Kiosk";

// A public-facing display must never redirect into the authenticated staff app,
// including when a permission refresh or expired session unmounts the kiosk.
export default function KioskRoute() {
  const { user, loading } = useAuth();
  if (!loading && user?.user_type === "staff" && canUseStaffPage(user, "kiosk")) {
    return <KioskPage />;
  }
  return (
    <main data-testid="kiosk-unavailable" className="min-h-screen flex items-center justify-center p-8"
      style={{ background: "#052F66", color: "#fff" }}>
      <p role="status">Kiosk display is unavailable.</p>
    </main>
  );
}
